import React from 'react'
import DatePicker from 'react-toolbox/lib/date_picker/DatePicker'
import moment from 'moment'

import theme from '../../styles/react-toolbox/theme.js'
import ThemeProvider from 'react-toolbox/lib/ThemeProvider'

const MaterialDatePicker = ({selectedDate, updateDate}) => {
  const jaLocale = {
    months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
    weekdaysShort: '(日)_(月)_(火)_(水)_(木)_(金)_(土)'.split('_'),
    weekdaysLetter: ['日', '月', '火', '水', '木', '金', '土']
  }
  const handleIconClick = function () {
    document.querySelector('div[data-react-toolbox="input"] input').click()
  }

  return (
    <div className="date_picker">
      <div className="picker_icon" onClick={handleIconClick}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
      </div>
      <ThemeProvider theme={theme}>
        <DatePicker
          value={selectedDate ? new Date(selectedDate) : new Date()}
          onChange={updateDate}
          locale={jaLocale}
          cancelLabel="キャンセル"
          inputFormat={ (date) => moment(date).format('YYYY-MM-DD') }
        />
      </ThemeProvider>
    </div>
  )
}

export default MaterialDatePicker



// WEBPACK FOOTER //
// ./src/components/_common/MaterialDatePicker.js